import type { Not } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const notResolver = createSimpleNamedExpressionResolver<Not>(
  'not',
  value => !value
);
